import { render, staticRenderFns } from "./GoogleAnalyticsView.vue?vue&type=template&id=03890f4e&scoped=true&"
import script from "./GoogleAnalyticsView.vue?vue&type=script&lang=js&"
export * from "./GoogleAnalyticsView.vue?vue&type=script&lang=js&"
import style0 from "./GoogleAnalyticsView.vue?vue&type=style&index=0&id=03890f4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03890f4e",
  null
  
)

/* custom blocks */
import block0 from "./GoogleAnalyticsView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports